import { Box, Divider, Typography, useTheme } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppCheckbox } from 'components/atoms/StyledFormControls';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelectLanguageID } from 'redux/reducers/gl_translations_reducer/selectors';
import { StateStatus } from 'redux/utils/common';
import { ITabContentProps, PropertyFilterType } from '../configuration';
import ProductFilterActions from '../store/actions';
import * as ProductFilterSelectors from '../store/selectors';

const TabSuitableFor = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const dataSuitableFor = props.selections[PropertyFilterType.SuitableFor].data;
  const segments = ProductFilterSelectors.useGetSegments();
  const optionSuitableFor = segments?.data?.suitable_for?.options ?? [];
  const language = useSelectLanguageID();
  React.useEffect(() => {
    if (!segments.data) {
      dispatch(
        ProductFilterActions.fetchSegmentsAction({ language: language })
      );
    }
  }, [dispatch]);

  const onClicked = (idData: string, keyName: 'suitable_for') => {
    let selectedValue = dataSuitableFor[keyName]
      ? dataSuitableFor[`${keyName}`]?.split(',') ?? []
      : [];
    var found = false;
    for (let selectedId of selectedValue) {
      if (selectedId === idData) {
        found = true;
      }
    }
    if (found) {
      selectedValue = selectedValue.filter((item) => item !== idData);
    }
    if (!found) selectedValue.push(idData);
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.SuitableFor]: {
          ...props.selections[PropertyFilterType.SuitableFor],
          ...(selectedValue.length > 0
            ? {
                isChecked: true,
              }
            : { isChecked: false }),
          data: {
            ...dataSuitableFor,
            [`${keyName}`]:
              selectedValue.length > 0 ? selectedValue.join(',') : null,
          },
        },
      })
    );
  };
  return (
    <Box
      style={{
        position: 'relative',
      }}
    >
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2
          translationKey={`suitable_for`}
          defaultText="Suitable for"
        />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2
          translationKey={''}
          defaultText={'Select one or more'}
        />
      </Typography>
      <Box>
        {(optionSuitableFor && optionSuitableFor.length > 0
          ? optionSuitableFor
          : []
        ).map((option, index) => {
          return (
            <React.Fragment key={option.id}>
              <Box
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                style={{
                  padding: '.25rem',
                  paddingLeft: 0,
                  cursor: 'pointer',
                }}
                onClick={() =>
                  onClicked(option.systemname ?? '', 'suitable_for')
                }
              >
                <AppCheckbox
                  size={'medium'}
                  checked={
                    !!dataSuitableFor.suitable_for &&
                    dataSuitableFor.suitable_for?.indexOf(
                      option?.systemname ?? ''
                    ) >= 0
                  }
                />
                <Typography style={{ marginLeft: '12px' }}>
                  {option.name}
                </Typography>
              </Box>
              {index + 1 < optionSuitableFor.length ? <Divider /> : null}
            </React.Fragment>
          );
        })}
        <Box marginBottom={'12px'}></Box>
      </Box>
      {segments.status === StateStatus.Pending ? (
        <Box
          style={{
            display: 'flex',
            position: 'absolute',
            right: '50%',
          }}
        >
          <CircularProgress />
        </Box>
      ) : null}
    </Box>
  );
};

export default TabSuitableFor;
